// module.exports = {
//import { EventBus } from './services/event-bus';
import MyProcessListAPI from "./services/MyProcessListAPI";
import typeAheadUtils from "./typeahead_utils";

const API_Lookup_Utils = {
    apiResponseData: [],
    mappingValues: [],
    displayValue: '',
    fetchDataTableDataByApilookup(selectedWidget) {
        var serviceParameters = selectedWidget.property.apilookup["data_json"]
        var esystem = selectedWidget.property.apilookup['data_esystem'];
        var eAPI = selectedWidget.property.apilookup['data_eapi'];
        var eAdapter = selectedWidget.property.apilookup['data_eadapter'];

        if (esystem && esystem != "" && eAPI && eAPI != "" && eAdapter && eAdapter != "") {
            var url = "/adapters/" + esystem + "/" + eAPI + "/" + eAdapter;
            $.each(JSON.parse(serviceParameters), function (i, value) {
                var paramName = value.paramName;
                var paramValue = value.paramValue;
                if (value.paramFormValue != "") {
                    paramValue = $(`[name='${value.paramFormValue}']`).val();
                }
                url = url + ((i == 0) ? "?" : "&") + paramName + "=" + encodeURI(paramValue);
            });
            var self = this;
            if (url && url != "") {
                return MyProcessListAPI.getDataForAPILookupService(url).then(responseData => {
                    var dataField = selectedWidget.property.apilookup['data_field'];
                    if (responseData) {
                        var resultArray;
                        if (dataField == null || dataField == "") {
                            resultArray = responseData;
                        } else {
                            resultArray = this.getAPILookupArray(dataField, responseData);
                        }
                        return resultArray;
                    }
                });
            }
        }
        return new Promise((resolve, reject) => {
            resolve([]);
        });
    },
    renderApiLookupDataField(selectedWidget) {
        var serviceParameters = $(selectedWidget).attr("apilookup_data_json")
        var esystem = $(selectedWidget).attr('apilookup_data_esystem');
        var eAPI = $(selectedWidget).attr('apilookup_data_eapi');
        var eAdapter = $(selectedWidget).attr('apilookup_data_eadapter');

        if (esystem && esystem != "" && eAPI && eAPI != "" && eAdapter && eAdapter != "") {
            var url = "/adapters/" + esystem + "/" + eAPI + "/" + eAdapter;
            $.each(JSON.parse(serviceParameters), function (i, value) {
                var paramName = value.paramName;
                var paramValue = value.paramValue;
                var paramFormValue =value.paramFormValue;
                var valueField = document.querySelectorAll(`[name="${paramFormValue}"]`)[0].getAttribute("data_value_field");
                
                if (value.paramFormValue != "") {
                    var dataArray = document.querySelectorAll(`[name="${paramFormValue}"]`)[0].getAttribute("data_ta_src");
                    if (dataArray) {
                        var data = JSON.parse(dataArray);
                        
                        paramValue = data.filter(function (chain) {
                             if (valueField !== "") {
                                var objIndex = data.findIndex((obj => obj.name == chain.name));
                                let temp = data[objIndex].name;
                                data[objIndex].name = data[objIndex].value;
                                data[objIndex].value = temp;
                            }
                             return chain.dispField === $(`[name='${value.paramFormValue}']`).val();
                        });

                        if(paramValue.length === 1){
                            paramValue = paramValue[0].value;
                        } else {
                            paramValue = $(`[name='${value.paramFormValue}']`).val();
                        }
                    } else {
                        paramValue = $(`[name='${value.paramFormValue}']`).val();
                    }
                }
                url = url + ((i == 0) ? "?" : "&") + paramName + "=" + encodeURI(paramValue);
            });
            $(selectedWidget).attr('data_src_url', url);
            this.renderAPIDataWithService(url, selectedWidget);
        }
    },
    loadData(responseData, fieldObj) {
        var self = this;
        this.displayValue = "";
        this.mappingValues = [];
        var dataField = $(fieldObj).attr('apilookup_data_field');
        this.mappingValues = JSON.parse($(fieldObj).attr("mappingValues"));
        this.displayValue = $(fieldObj).attr('apilookup_data_disp_field');
        if (responseData) {
            var resultArray;
            if (dataField == null || dataField == "") {
                resultArray = responseData;
            } else {
                resultArray = this.getAPILookupArray(dataField, responseData);
            }
            if (resultArray != null) {
                if (!Array.isArray(resultArray)){
                    resultArray= resultArray.data
                }
                if (Array.isArray(resultArray) && resultArray.length > 1) {
                    if (this.displayValue == null || this.displayValue == "") {
                        this.displayValue = "{" + Object.keys(resultArray[0])[0] + "}";
                    }
                    var displayJsonFields = this.displayValue.match(/{([^}]+)}/g);
                    this.apiResponseData = resultArray;
                    this.loadSelectInDialog(resultArray, displayJsonFields);
                    $('#apiLookupSelectDataDialog')[0].show();
                } else if (Array.isArray(resultArray) && resultArray.length == 1) {
                    for (var i = 0; i < this.mappingValues.length; i++) {
                        var value;
                        var jsonFieldName = this.mappingValues[i].jsonFieldName;
                        if (jsonFieldName.indexOf(".") != -1) {
                            var fieldArray = jsonFieldName.split(".");
                            var fieldData = resultArray[0][fieldArray[0]];
                            if (fieldData == null) {
                                return;
                            }
                            for (var k = 1; k < fieldArray.length; k++) {
                                fieldData = fieldData[fieldArray[k]];
                            }
                            value = fieldData;
                        } else {
                            value = resultArray[0][this.mappingValues[i].jsonFieldName];
                        }
                        $("[name='" + this.mappingValues[i].fieldName + "']").val(value);
                    }
                } else {
                    for (var i = 0; i < this.mappingValues.length; i++) {
                        var jsonFieldName = this.mappingValues[i].jsonFieldName;
                        var value = resultArray[jsonFieldName];
                        if (jsonFieldName.indexOf(".") != -1) {
                            var fieldArray = jsonFieldName.split(".");
                            var fieldData = resultArray[fieldArray[0]];
                            if (fieldData == null) {
                                return;
                            }
                            for (var k = 1; k < fieldArray.length; k++) {
                                fieldData = fieldData[fieldArray[k]];
                            }
                            value = fieldData;
                        }

                        $("[name='" + this.mappingValues[i].fieldName + "']").val(value);
                    }
                }
            }
        }
    },
    initializeSelect(arrayOptions) {
        let selectFields = document.querySelector('#dataArraySelectCmp')?.slim;
			if(!selectFields) {
				selectFields = new SlimSelect({
					select: '#dataArraySelectCmp',      
				})
			}
        var option = {
            text: 'Select an Option',
            placeholder: true,
            value: ''
        };
        arrayOptions.splice(0, 0, option);
        selectFields.setData(arrayOptions);
    },
    loadSelectInDialog(resultArray, displayJsonFields) {
        var self = this;
        let arrayOptions = [];
        $.each(resultArray, function (i, value) {
            var displayText = self.displayValue;
            if (Array.isArray(displayJsonFields)) {
                $.each(displayJsonFields, function (j, displayJsonField) {
                    var jsonFieldValue = displayJsonField.substr(1).slice(0, -1);
                    if (jsonFieldValue.indexOf(".") != -1) {
                        var jsonFieldArray = jsonFieldValue.split(".");

                        for (var fieldIndex = 0; fieldIndex < jsonFieldArray.length - 1; fieldIndex++) {
                            if (value.hasOwnProperty(jsonFieldArray[fieldIndex])) {
                                if (value[jsonFieldArray[fieldIndex]] != null || value[jsonFieldArray[fieldIndex]] != undefined) {
                                    value = value[jsonFieldArray[fieldIndex]];
                                }
                            }
                        }
                        var sRegExInput = new RegExp(displayJsonField.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), "g");
                        displayText = displayText.replace(sRegExInput, value[jsonFieldArray[jsonFieldArray.length - 1]]);

                    }
                    else if (value.hasOwnProperty(jsonFieldValue)) {
                        if (value[jsonFieldValue] != null || value[jsonFieldValue] != undefined) {
                            var sRegExInput = new RegExp(displayJsonField.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), "g");
                            displayText = displayText.replace(sRegExInput, value[jsonFieldValue]);
                        }
                    }
                });
            }
            var option = {
                text: displayText,
                value: i + 1,
                selected: API_Lookup_Utils.checkForSelected(displayText)
            };

            arrayOptions.push(option);
        });
        this.initializeSelect(arrayOptions);
    },
    checkForSelected(displayText) {
        let check = false;
        if (!check) {
            this.mappingValues.forEach(element => {
                var feildNameVar = element.fieldName;
                if (displayText === document.querySelectorAll(`[name="${feildNameVar}"]`)[0].value.split(" - ")[0]) {
                    check = true;
                }
            });
        }
        return check;
    },
    renderAPIDataWithService(systemURL, ele) {
        var self = this;
        if (systemURL && systemURL != "" && ele != null) {
            MyProcessListAPI.getDataForAPILookupService(systemURL).then(result => {
                self.loadData(result, ele);
            });

        }
    },
    setApiLookupValue(selectedVal) {
        var self = this;
        if (selectedVal != null && selectedVal != "") {
            for (var i = 0; i < self.mappingValues.length; i++) {
                var jsonFieldName = self.mappingValues[i].jsonFieldName;
                if (jsonFieldName.indexOf(".") != -1) {
                    var jsonFieldArray = jsonFieldName.split(".");
                    var value = self.apiResponseData[selectedVal - 1];
                    for (var fieldIndex = 0; fieldIndex < jsonFieldArray.length - 1; fieldIndex++) {
                        if (value.hasOwnProperty(jsonFieldArray[fieldIndex])) {
                            if (value[jsonFieldArray[fieldIndex]] != null || value[jsonFieldArray[fieldIndex]] != undefined) {
                                value = value[jsonFieldArray[fieldIndex]];
                            }
                        }
                    }
                    $("[name='" + self.mappingValues[i].fieldName + "']").val(value[jsonFieldArray[jsonFieldArray.length - 1]]);

                } else {
                    var value = self.apiResponseData[selectedVal - 1][self.mappingValues[i].jsonFieldName];
                    $("[name='" + self.mappingValues[i].fieldName + "']").val(value);
                }
            }
        }
    },
    findElementById(objName) {
        return $('#' + objName + '');
    },
    getAPILookupArray(dataField, responseData) {
        var resultArray = [];
        var splittedDataSource = dataField.split(".");
        if (splittedDataSource.length == 1 && responseData.hasOwnProperty(splittedDataSource[0])) {
            resultArray = responseData[splittedDataSource[0]];
        } else if (splittedDataSource.length == 1) {
            resultArray = typeAheadUtils.recursiveSearchTypeAheadJSON(dataField, responseData);
        } else if (splittedDataSource.length > 1) {
            var firstEle = splittedDataSource[0];
            var arrayEle;
            var arrayIndex;
            if (responseData.hasOwnProperty(firstEle) || (firstEle.indexOf("[") != -1 && firstEle.indexOf("]") != -1 && responseData.hasOwnProperty(firstEle.split("[")[0]))) {
                if (firstEle.indexOf("[") != -1 && firstEle.indexOf("]") != -1) {
                    arrayEle = firstEle.split("[")[0];
                    arrayIndex = firstEle.split("[")[1].split("]")[0];
                    resultArray = responseData[arrayEle][arrayIndex];
                } else {
                    resultArray = responseData[firstEle];
                }
                for (var ind = 1; ind < splittedDataSource.length; ind++) {
                    var currentEle = splittedDataSource[ind];
                    if (resultArray.hasOwnProperty(currentEle)) {
                        resultArray = resultArray[currentEle];
                    } else if (currentEle.indexOf("[") != -1 && currentEle.indexOf("]") != -1) {
                        arrayEle = currentEle.split("[")[0];
                        arrayIndex = currentEle.split("[")[1].split("]")[0];
                        if (resultArray.hasOwnProperty(arrayEle)) {
                            resultArray = resultArray[arrayEle][arrayIndex];
                        } else {
                            resultArray = [];
                        }
                    } else {
                        resultArray = [];
                    }
                }
            }
        }
        return resultArray;
    }
}

window.API_Lookup_Utils = API_Lookup_Utils;
export default API_Lookup_Utils;